import http from "@/plugins/http";

// 列表
export function getAreaTree(data) {
  return http({
    url: `/area/getWebTree`,
    params:data,
    method: 'GET',
  })
}

